/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Saturday, May 21st 2022, 1:38:13 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { Link } from "react-router-dom";
import { SaaSOnlyWrapper } from "authorization";
import { URLS } from "core/routes";

export const AdminSignupLink = () => (
  <SaaSOnlyWrapper>
    <span>
      <Link to={URLS.signup}>Create admin account</Link>
    </span>
  </SaaSOnlyWrapper>
);
